import { FC } from 'react';

import { Avatar, Badge, Flex, Layer, useBreakpoint } from '@hh.ru/magritte-ui';

import useTrls from 'hooks/translation/useTrls';

import { useSelector } from 'store/utils';

import styles from 'components/Banners/components/Banner/components/BannerInfo/components/BannerImages/BannerImages.module.less';

interface BannerImagesProps {
    imageUrl: string;
    videoThumbnailUrl: string;
}

const TrlKeys = {
    badge: 'BannersPage.banner.badges.video',
};

export const BannerImages: FC<BannerImagesProps> = ({ imageUrl, videoThumbnailUrl }) => {
    const { isMobile } = useBreakpoint();
    const webdavPublicUrl = useSelector((state) => state.clickme.webdavPublicUrl);
    const trls = useTrls();

    return (
        <Flex gap={8} direction={isMobile ? 'column-reverse' : 'row'} justify="start">
            {videoThumbnailUrl && (
                <div className={styles.videoPreview}>
                    <Avatar
                        mode="image"
                        image={videoThumbnailUrl}
                        size={isMobile ? 48 : 120}
                        aria-label={videoThumbnailUrl}
                    />
                    <Layer layer="drop">
                        <div className={isMobile ? styles.videoBadgeMobile : styles.videoBadgeDesktop}>
                            <Badge style={isMobile ? 'accent' : 'constant'} size="small">
                                {trls(TrlKeys.badge)}
                            </Badge>
                        </div>
                    </Layer>
                </div>
            )}
            <div className={styles.imageContainer}>
                <Avatar
                    mode="image"
                    image={`${webdavPublicUrl}/${imageUrl}`}
                    size={isMobile ? 48 : 120}
                    aria-label={imageUrl}
                />
            </div>
        </Flex>
    );
};
